
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import Dialog from '@/components/dialog.vue';
	import {
		grade
	} from '@/utils/config';
	import {
		performanceStatisticproductDistributedList
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"

	@Component({
		name: 'user-detail-dialog',
		components: {
			'slz-dialog': Dialog
		}
	})
	export default class UserDetailDialog extends Vue {
		@Model('change') isShow!: boolean;
		@Prop({}) private info!: any;
		@Prop({}) private time: any;
		private loading = false;
		private showDialog = false;
		private alllist:any = []
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private orderNo = '';
		
		@Watch('isShow')
		private onChangeShow(val: boolean) {
			this.showDialog = val;
			if (val) {
				this.getList();
			}
		}

		private handleClose() {
			this.keywords = ''
			this.pageNo = 1
			this.$emit('change', false);
		}
		
		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}
		
		private doSearch(){
			this.pageNo = 1;
			this.getList();
		}
		
		private async getList() {
			let params: any = {
				MemberId: this.info.MemberId,
				RoleGrade: this.info.RoleGrade,
				SuperId: this.info.SuperId,
				RecommendId: this.info.RecommendId,
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords,
				ProductIds:this.info.ProductIds,
				State:this.info.State
			}
			
			let times: any = '';
			if (this.time){
				times = this.time.split('/');
			}
			if (times) {
				params.StartTime = times[0];
				params.EndTime = nextDay(times[1],1);
			}
			this.loading = true;
			try {
				const res: any = await performanceStatisticproductDistributedList(params);
				this.alllist = res.Result.Results;
				this.total = res.Result.Total;
				this.paging()
			} catch (e) {
				console.log(e);
			}finally{
				this.loading = false;
			}
		}

		private paging(){
			this.list = this.alllist.filter((v,i)=>{
				return i>=(this.pageNo-1)*this.pageSize && i <this.pageNo*this.pageSize
			})
		}
		
		private handleExport(){
			
			let times: any = '';
			if (this.time){
				times = this.time.split('/');
			}
			
			let url = location.origin + '/pc/performanceStatistic/productDistributedExport?' + 
				'MemberId=' + this.info.MemberId +
				'&RoleGrade=' + this.info.RoleGrade + 
				'&SuperId=' + this.info.SuperId + 
				'&RecommendId=' + this.info.RecommendId + 
				'&Keywords=' + this.keywords + 
				'&StartTime=' + (times[0]||'') + 
				'&EndTime=' + (times[1]?nextDay(times[1],1):'')+
				'&ProductIds=' + this.info.ProductIds + 
				'&State=' + (this.info.State!==null?this.info.State:'');
			
			window.open(url)
		}
		
	}
